var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.75,
    width: 37.5,
    height: 37.5,
    rx: 18.75,
    stroke: "#979797",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6775 21.424C20.2105 21.7336 19.668 21.8973 19.1087 21.8973C18.5494 21.8973 18.0069 21.7336 17.5399 21.424L9.84765 16.3245C9.80497 16.2962 9.76339 16.2667 9.72266 16.2364V24.5925C9.72266 25.5506 10.5045 26.3109 11.4508 26.3109H26.7666C27.7301 26.3109 28.4947 25.5334 28.4947 24.5925V16.2363C28.4539 16.2667 28.4122 16.2963 28.3695 16.3246L20.6775 21.424Z",
    fill: "#004B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4578 15.4142L18.15 20.5137C18.4412 20.7068 18.775 20.8033 19.1087 20.8033C19.4424 20.8033 19.7762 20.7067 20.0674 20.5137L27.7596 15.4142C28.2199 15.1092 28.4947 14.5988 28.4947 14.0479C28.4947 13.1007 27.7198 12.3301 26.7672 12.3301H11.4502C10.4976 12.3301 9.72266 13.1007 9.72266 14.0488C9.72266 14.5988 9.99749 15.1092 10.4578 15.4142Z",
    fill: "#004B6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    fill: "white",
    transform: "translate(9 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailsvg);
export default __webpack_public_path__ + "static/media/EMAILSVG.6dd1aa95d373bb3aabc8dc47bd32c541.svg";
export { ForwardRef as ReactComponent };